import React from 'react';
import { Body, LegalBody, Step, StepLabel, Stepper } from '@indigo-ag/component-module';
import { CreditApprovalStep, CreditApprovalStepType } from '@indigo-ag/schema';

import { CreditApprovalStepStatus } from './CreditApprovalStepStatus';
import { utils } from 'shared';
import i18next from 'core/i18n';

const APPROVAL_TYPE_TRANSLATION: Record<CreditApprovalStepType, string> = {
  [CreditApprovalStepType.CREDIT_ANALYST_APPROVAL]: i18next.t('creditAnalyst'),
  [CreditApprovalStepType.CREDIT_SUPERVISOR_APPROVAL]: i18next.t('creditSupervisor'),
  [CreditApprovalStepType.CREDIT_MANAGER_APPROVAL]: i18next.t('creditManager'),
  [CreditApprovalStepType.COMMERCIAL_DIRECTOR_APPROVAL]: i18next.t('commercialDirector'),
  [CreditApprovalStepType.FINANCE_DIRECTOR_APPROVAL]: i18next.t('financeDirector')
};

interface CreditApprovalTimelineProps {
  steps: CreditApprovalStep[];
}

export const CreditApprovalTimeline: React.FunctionComponent<CreditApprovalTimelineProps> = ({ steps }) => {
  // TODO: pending resolve decision by and display it next to updated at date

  return (
    <Stepper activeStep={steps.findIndex(s => !s.decision) || 0} orientation="vertical" className="pl-0">
      {utils.CreditApprovalUtil.sortSteps(steps).map(step => (
        <Step key={step.id} completed={!!step.decision}>
          <StepLabel>{utils.text.toTitleCase(APPROVAL_TYPE_TRANSLATION[step.approvalType])}</StepLabel>
          <div className="ml-5">
            <CreditApprovalStepStatus stepDecision={step.decision} />
            {step.decisionNotes ? <Body>{`${i18next.t('notes')}: ${step.decisionNotes}`}</Body> : null}
            {step.decisionBy ? (
              <LegalBody className="mt-1">{`${utils.date.formatDate(step.updatedAt, 'L LT')} ${i18next.t(
                'by'
              )} ${utils.UserUtil.getUserFullName(step.decisionBy)}`}</LegalBody>
            ) : null}
          </div>
        </Step>
      ))}
    </Stepper>
  );
};
